import {
  getSelfList,
  memberselfEdit,
  updateSelf,
  delSelf,
  confirmSelfPickUp,
  getSellerCredential,
  getHLOrderInfo,
  confirmSelfPickUpData
} from "@/api/pickUp";

export default {
  namespaced: true,
  actions: {
    async getSelfList(context, params) {
      const res = await getSelfList(params);
      return res;
    },

    async updateSelf(context, params) {
      const res = await updateSelf(params);
      return res;
    },

    async memberselfEdit(context, params) {
      const res = await memberselfEdit(params);
      return res;
    },

    async delSelf(context, params) {
      const res = await delSelf(params);
      return res;
    },

    async confirmSelfPickUp(context, params) {
      const res = await confirmSelfPickUp(params);
      return res;
    },

    async getSellerCredential(context, params) {
      const { data } = await getSellerCredential(params);
      return data;
    },

    async getHLOrderInfo(context, params) {
      const { data } = await getHLOrderInfo(params);
      return data;
    },

    async confirmSelfPickUpData(context, params) {
      const res = await confirmSelfPickUpData(params);
      return res;
    }
  }
};
